// extracted by mini-css-extract-plugin
export default {"modalOverlay":"AlertModal_modalOverlay__mfGky","modalBox":"AlertModal_modalBox__RBP15","modalButton":"AlertModal_modalButton__xc1oY"};